import classNames from 'clsx';
import * as React from 'react';

import * as styles from './SubwayInfo.css';

interface ISubwayInfoProps {
  subwayIcon: React.ReactNode;
  title: React.ReactNode;
  typeIcon: React.ReactNode;
  subwayColor: string;
  time: React.ReactNode;
}

export function SubwayInfo({ subwayIcon, subwayColor, title, time, typeIcon }: ISubwayInfoProps) {
  return (
    <div className={styles['info']}>
      <div className={classNames(styles['info__group'], styles['info__group--title'])}>
        <span className={styles['icon']} style={{ color: subwayColor }}>
          {subwayIcon}
        </span>
        {title}
      </div>
      <div className={classNames(styles['info__group'], styles['info__group--time'])}>
        <span className={classNames(styles['icon'], styles['type'])}>{typeIcon}</span>
        {time}
      </div>
    </div>
  );
}
